import _trimEnd from 'lodash/trimEnd';

module.exports = {
  path: ':id',
  indexRoute: {
    onEnter: (nextState, replace) => replace(`${_trimEnd(nextState.location.pathname, '/')}/dashboard`),
  },
  getChildRoutes(partialNextState, cb) {
    require.ensure([], (require) => {
      cb(null, [
        require('./routes/dashboard'),
        require('./routes/showcase'),
        require('./routes/information'),
        require('./routes/customers'),
        require('./routes/parkings'),
        require('./routes/bookings'),
        require('./routes/oneparkBookings'),
        require('./routes/onDemands'),
        require('./routes/onDemandsNew'),
        require('./routes/accesses'),
        require('./routes/metricsAccess'),
        require('./routes/metricsOccupancyRate'),
        require('./routes/metricsRevenue'),
        require('./routes/invoices'),
        require('./routes/settings'),
        require('./routes/newSettings'),
        require('./routes/plannings'),
        require('./routes/configuration'),
        require('./routes/priceGrids'),
        require('./routes/equipments'),
      ]);
    });
  },
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/CarparkShow'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/routes/show/index.js